let comingSoonEl = document.getElementById('comingSoon');
if (comingSoonEl) {
	comingSoonEl.addEventListener('click', (e) => {
		comingSoonEl.classList.add('hide');
	})
}
